import Tabs from 'antd/lib/tabs';
import { FormattedMessage } from 'react-intl';

import config from 'config/index';
import { PageWrapper } from 'modules/layout';

import PartnersForm from '../../containers/PartnersForm';

const TabPane = Tabs.TabPane;
const PartnersPage = () => (
    <PageWrapper header={<FormattedMessage id="partners.title" values={{ event: config.app.name }} />}>
        <Tabs>
            {config.app.languages
                ?.sort(a => (a === config.app.defaultLanguage ? -1 : 0))
                .map(lang => (
                    <TabPane tab={<FormattedMessage id={`languages.${lang}`} />} key={lang}>
                        <PartnersForm language={lang} />
                    </TabPane>
                ))}
        </Tabs>
    </PageWrapper>
);

export default PartnersPage;
